import { FETCH_TYPES, parseURL } from "../Connect";
import SystemConfig, { CONFIG_PARAMS } from "../../system/SystemConfig";
import AddResult from "../result/AddResult";
import FetchAjax from "../FetchAjax";
import IConnectControl from "../controllers/IConnectControl";
import { inject, injectable } from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import AbstractConnect from "./AbstractConnect";
import IDOM from "../../ui/IDOM";
import AbstractUIScreen, {
  ORIENTATION,
} from "../../ui/screen/AbstractUIScreen";
import {
  JokerBonusMode,
  JokerWinBanner,
} from "../../../../src/JokerWinBanner/src/JokerWinBanner";
import { IJokerBonusWinData } from "../../../../src/JokerWinBanner/src/interfaces/IJokerBonusWinData";
import JOKER_BONUS_IDENTIFIERS from "../../../../src/JokerWinBanner/src/constants/identifiers";
import AbstractAudio from "../../engine/AbstractAudio";

@injectable()
export default class ConnectAjaxAdd extends AbstractConnect {
  public readonly fetchType: string = FETCH_TYPES.ADD;
  timeout: number = 20000;

  private screen: AbstractUIScreen;

  constructor(
    @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
    @inject(SERVICE_IDENTIFIER.ConnectControl) control: IConnectControl,
    @inject(SERVICE_IDENTIFIER.FetchAjax) fetch: FetchAjax,
    @inject(SERVICE_IDENTIFIER.DOM) dom: IDOM,
    @inject(SERVICE_IDENTIFIER.UIScreen) screen: AbstractUIScreen,
    @inject(SERVICE_IDENTIFIER.EngineAudio) protected audio: AbstractAudio,
    @inject(JOKER_BONUS_IDENTIFIERS.JOKER_WIN_BANNER_IDENTIFIER)
    protected jokerBonus?: JokerWinBanner,
  ) {
    super(config, control, fetch, dom);
    this.screen = screen;

    // use gameconf connect timeout if set,
    if (
      this.config.get(CONFIG_PARAMS.TIMEOUTS) &&
      this.config.get(CONFIG_PARAMS.TIMEOUTS).add > 0
    ) {
      this.timeout = this.config.get(CONFIG_PARAMS.TIMEOUTS).add * 1000;
      // @ts-ignore
      super.ajaxLoadingTimeout = this.timeout / 9;
    }
    this.setMethod(this.config.get(CONFIG_PARAMS.URL_ADD_METHOD));
  }

  async fetch(data) {
    this.control.reset();
    this.data = data;

    this.initTimeoutLoading();

    try {
      let res = await this._fetch();
      let addResult = new AddResult(res.data);
      this.isSilentClose = addResult.isSilentClose();
      return addResult;
    } catch (e) {
      return await Promise.reject(e);
    }
  }

  protected getParams(): Record<string, any> {
    let params: Record<string, any> = {
      lines_cnt: this.data.linesCount,
      atomic_bet: this.data.atomicBet,
      round_id: this.data.roundId,
      casino_id: this.data.casinoId,
      coin: this.data.coin,
      player_id: this.data.playerId != null ? this.data.playerId : undefined,
      session_key:
        this.data.sessionKey != null ? this.data.sessionKey : undefined,
      orientation: this.screen.getOrientation() == ORIENTATION.PORT ? 2 : 1,
      hand: this.data.hand,
      autostart: this.data.autostart,
      is_bonus: this.data.isBonus,
      sound: !this.audio.isMuted(),
    };

    try {
      if (this.jokerBonus?.mode !== JokerBonusMode.asynchronous) {
        const firstJackpot: IJokerBonusWinData | undefined =
          this.jokerBonus?.jackpots?.[0];
        params.jackpot_id = firstJackpot?.jackpot_id;
        params.ticket_id = firstJackpot?.ticket_id;
      }
    } catch (e) {
      console.warn("Adding joker bonus jackpot to round request failed", e);
    }

    return params;
  }

  protected getUrl(): string {
    return parseURL(this.config.get(CONFIG_PARAMS.URL_ADD), {
      server_api: this.data.serverApi,
      casino_id: this.data.casinoId,
      session_id: this.data.sessionId,
      round_id: this.data.roundId,
    });
  }
}
